@if (abandonedCartPoppingData) {
  @if (abandonedCartPoppingData(); as popinData) {
    @defer {
      <sd-modal-default
        [clickToClose]="true"
        [modalTitleLevel]="4"
        [(isOpened)]="isOpened"
        [hasHeader]="false"
        modalCustomClass="c__modal-abandoned-cart-form"
        (isOpenedChange)="saveClosed($event)"
      >
        <div class="c__image">
          @if (popinData.media) {
            <sd-banner [media]="{ url: popinData.media.url }" alt="Abandoned Cart Image" />
          }
        </div>
        <div class="c__text">
          <sd-title [titleLevel]="3" customClass="brand--h3">
            {{ popinData.title }}
          </sd-title>

          <p class="c__text_description">{{ popinData.description }}</p>

          <form [formGroup]="abandonedCartForm">
            <sd-form-input
              [labelTitle]="popinData.emailLabel"
              [formControl]="abandonedCartForm.controls.email"
              [placeholder]="popinData.emailPlaceHolder"
              [maxlength]="70"
              [required]="true"
              [suggestions]="suggestions()"
              (inputChanged)="popinData.useDataQualityFormValidation ? loadSuggestions($event) : null"
              (blurEvent)="popinData.useDataQualityFormValidation ? validateInput(InputTypeEnum.EMAIL) : null"
            >
              <ng-container sd-message>
                <sd-form-error
                  errorKey="pattern"
                  [errorLabel]="'newsletter.emailPatternError'| translate "
                  [control]="abandonedCartForm.controls.email"
                />
                <sd-form-error
                  errorKey="required"
                  [errorLabel]="'forms.email.required' | translate"
                  [control]="abandonedCartForm.controls.email"
                />
              </ng-container>
            </sd-form-input>

            @if (isLoading()) {
              <div sd-loader></div>
            } @else {
              <button class="action" sd-button type="submit" (click)="onSubmit()">
                {{ popinData.sendAction }}
              </button>
            }
          </form>

          <wc-captcha-turnstile
            (captchaTurnstileSuccess)="recaptchaValidated()"
            (captchaTurnstileError)="captchaError()"
          />

          <sd-html innerClass="c__text_terms" [html]="popinData.legalMentions" />

          <div class="c_popin_actions">
            <a class="c__shop" (click)="onCloseModal()">
              <span>{{ 'cart.minicart.actions.continue' | translate }}</span>
            </a>
            <a class="c__basket" (click)="onCloseModal()" routerLink="/cart">
              <span>{{ 'cart.minicart.actions.cart' | translate }}</span>
            </a>
          </div>

        </div>

      </sd-modal-default>
    }
  }
}
